import type { ResourcePermission as ResourcePermissionModel } from '@/adapters/catalogv1.g';

export function extractResourcePermission(model: ResourcePermissionModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    permissionRef: model.permission_ref ?? '',
    resourceRef: model.resource_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogResourcePermission = ReturnType<
  typeof extractResourcePermission
>;
